<script lang="ts">
  import { Button as BitsButton } from 'bits-ui';
  import type { ComponentProps } from 'svelte';

  type Props = ComponentProps<typeof BitsButton.Root> & {
    variant?: 'primary' | 'ghost' | 'destructive';
    size?: 'small' | 'big';
    full?: boolean;
  };

  let {
    variant,
    size,
    full = false,
    class: className = '',
    type = 'button',
    ref = $bindable(null),
    children,
    ...rest
  }: Props = $props();

  const classes = $derived(['btn', variant, size, full ? 'full' : '', className].filter(Boolean).join(' '));
  const rootProps = $derived({ ...rest, type, class: classes } as ComponentProps<typeof BitsButton.Root>);
</script>

<BitsButton.Root {...rootProps} bind:ref>
  {@render children?.()}
</BitsButton.Root>
